import React from 'react';
import NavBar from "../components/common/NavBar";
import Footer from "../components/common/Footer";
import OurHead from '../components/HomeComp/OurHead';
import TopImage from '../components/common/TopImage';

const AboutUsPage = () => {
  return (
    <div className='mt-20'>
      <NavBar />
      <TopImage text="About Us"/>
      <div className="flex flex-col items-center justify-center p-8 text-4xl font-bold text-red capitalize">
        <div>About us</div>
        <div className="text-4xl font-bold tracking-wider text-center text-black capitalize mt-10">
          Motherland Children Academy
        </div>
        <div className="text-base tracking-wide text-center font-'DM-Sans' font-normal text-black mt-10">
      Education transforms people into individuals who make choices wisely and
      courageously under any circumstance. It equips children with the ability
      to choose between wisdom and foolishness, good and bad deeds, regardless
      of the academic degree they possess. Good education embellishes the
      personality of a student. It inspires the child to develop his/her hidden
      talents and mould his/her character to perfection. It is the quintessence
      of a harmonious growth of the mind, body and senses.
      <br />
      Keeping all these aspects of modern education in mind, Motherland children
      Academy has created an educational ecosystem that can make all these
      aspects a reality. We are committed to preparing young minds to become
      responsible citizens capable of building a prosperous nation. A
      co-educational school that imparts education through the medium of
      English, it is one of the most prestigious institutions managed by the
      Motherland Education Society. The school, affiliated to CBSE, provides a
      sound education through a well-designed curriculum and helps students
      develop physically, intellectually and morally. Ultimately, our aim is to
      enable our students to find their place in the challenging world of
      tomorrow.
    </div>
      </div>
      <div>
        <OurHead/>
      </div>
      <Footer />
    </div>
  );
}

export default AboutUsPage;
